import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class AssistResolver  {
    resolve(route: ActivatedRouteSnapshot) {
      return route.params['assist'] === 'true';
    }

}
